<template>
    <div class="login-header comp">
        <div class="header-top">
            <div class="header-top-container">
                <div class="header-content">
                    <img
                        :src="
                            $util.imgSrc({
                                fileCode: $cache.getCompanyInfoParam('10101007')
                            })
                        "
                        height="36"
                        alt=""
                        style="margin-right: 10px"
                        v-on:click.prevent="$router.push({ name: 'login' })"
                    />

                    <a
                        v-for="(item, index) in linkData"
                        :key="index"
                        :class="{ line: index > 0 }"
                        :href="item.address"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {{ item.name }}
                    </a>
                </div>
                <div v-if="$cache.getCompanyInfoParam('10101009')" class="flex">
                    <div class="service">
                        <img :src="require('../../assets/img/loginPage/service-icon.png')" />
                        <span class="serviceTip">
                            客服热线
                            <span class="hotline-text">
                                {{ $cache.getCompanyInfoParam("10101009") }}
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import userApi from "@/api/user";
export default {
    name: "LoginHeader",
    components: {},
    props: {
        tit: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            info: {},
            otherInfo: {},
            login: false,
            menuHidden: false,
            linkData: [] // 顶部栏展示链接
        };
    },
    watch: {
        "$store.state.user.info"() {
            this.info = this.$cache.getUser();
        }
    },
    mounted() {
        this.info = this.$cache.getUser();
        document.title = this.$cache.getCompanyInfoParam("10101001") || this.$route.meta.nameText;
        this.login = this.$store.state.login.status;
        this.menuHidden = this.$route.meta.menuHidden;
        this.linkData = this.$cache.getCompanyInfoParam("10105007")
            ? JSON.parse(this.$cache.getCompanyInfoParam("10105007"))
            : [];
        this.qryCrmCustInfo();
    },
    methods: {
        async qryCrmCustInfo() {
            const otherUserInfo = this.$cache.getUserOtherInfo();
            if (otherUserInfo && otherUserInfo.custnoCrm) {
                const res = await userApi.qryCrmCustInfo({
                    custnoCrm: otherUserInfo.custnoCrm
                });
                this.otherInfo = res.data;
            }
        },
        async logoff() {
            const res = await userApi.logout();
            if (res.error) return;
            this.$store.dispatch("logout", res.data).then(() => {
                this.$router.replace("/");
            });
        },
        toModifyRemark() {
            if (this.$route.fullPath === "/acctManager?activeIndex=2") {
                this.$store.commit("updateView", { action: "remark-click" });
            } else {
                this.$router.push({
                    name: "acctManager",
                    query: { activeIndex: "2" },
                    params: { next: "remark" }
                });
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.login-header {
    background-color: $bg2;
    min-width: 1200px;
    border-bottom: 3px solid var(--color-primary);

    .header-top {
        // background: $bg1;
        background: #ffffff;
        font-size: 16px;
        color: $text-color1;
        .header-top-container {
            height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 1200px;
            margin: 0 auto;
            height: 64px;

            .header-content {
                display: flex;
                align-items: center;
            }

            .line {
                position: relative;
                &:before {
                    content: "";
                    height: 17px;
                    margin: 0 10px;
                    border-left: 1px solid var(--color-text-regular);
                }
            }
        }
        .service,
        .logoff {
            // color: $bg18;
            display: flex;
            align-items: center;

            .serviceTip {
                .hotline-text {
                    margin-left: 10px;
                    color: var(--color-primary);
                }
            }
            img {
                width: 14px;
                height: 15px;
                margin-right: 6px;
            }
        }
        .logoff img {
            width: 13.5px;
            height: 13.5px;
        }
        span {
            display: inline-block;
        }
        .line {
            position: relative;
            &:before {
                content: "";
                height: 17px;
                margin: 0 10px;
                border-left: 1px solid var(--color-text-regular);
            }
        }
    }
    .container {
        position: relative;
        height: 100%;
        .header-box {
            height: 80px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .logo {
            margin-top: 0;
            display: inline-block;
            display: flex;
            align-items: center;
            .tit {
                display: inline-block;
                color: $text-color2;
                font-size: $f22;
                min-width: 200px;
                font-weight: 500;
            }
            .tit:before {
                content: "";
                margin: 0 24px 0 34px;
                border-left: 1px solid var(--color-text-weak);
            }
            img {
                vertical-align: middle;
                height: 36px;
            }
        }
        .menu {
            outline: none;
        }
        .links {
            font-size: 14px;
            color: $text-color1;
            li {
                display: inline-block;
                margin-left: 12px;
            }
        }
    }
    .hoverCursor {
        &:hover {
            cursor: pointer;
            color: var(--color-primary);
        }
    }
}
</style>
